import heroDesktop from "@assets/images/hsa-fsa/hero-desktop.webp";
import heroMobile from "@assets/images/hsa-fsa/hero-mobile.webp";
import heroSmallDesktop from "@assets/images/hsa-fsa/hero-small-desktop.webp";
import heroTablet from "@assets/images/hsa-fsa/hero-tablet.webp";
import Button from "@/blueprint/components/Button/Button";
import ResponsiveArt from "@/blueprint/components/ResponsiveArt/ResponsiveArt";
import MountReveal from "@/blueprint/components/ScrollReveal/MountReveal";
import Section from "@/blueprint/components/Section/Section";
import { SITE_LINKS } from "@/data/siteLinks";
import { HSA_FSA_HERO } from "@/views/hsa-fsa/hsaFsaContent";
import { cn } from "@/lib/utils";

const MEDIA_HEIGHT = "h-[650px] tab:h-[784px] sd:h-[648px] d:h-[812px]";

const HsaFsaHero = ({ position }: { position: number }) => (
  <Section
    id="hsa-fsa-hero"
    position={position}
    ariaLabelledBy="hsa-fsa-hero-heading"
    className="flex flex-col items-center bg-brand-grey px-grid-margin pb-[18px] pt-[20px] tab:pb-[32px] tab:pt-[24px] sd:pb-[64px] sd:pt-[32px] d:pt-[40px]"
  >
    <div
      className={cn(
        "relative w-full overflow-hidden rounded-24 sd:rounded-32 d:rounded-24",
        MEDIA_HEIGHT,
      )}
    >
      {/* TODO(agency): the hero is a video that has not been delivered; swap in a
          muted, looping, playsInline <video> with these as its poster, and move the
          scrim baked into the posters into CSS. */}
      <ResponsiveArt
        sources={{
          mobile: heroMobile,
          tablet: heroTablet,
          sd: heroSmallDesktop,
          desktop: heroDesktop,
        }}
        alt={HSA_FSA_HERO.mediaAlt}
        sizes="100vw"
        priority
        className="absolute inset-0 h-full w-full object-cover"
      />

      <div className="absolute inset-0 flex flex-col items-center justify-center gap-[20px] px-[18px] tab:gap-[24px] tab:px-[32px] sd:px-[32px] d:gap-[32px] d:px-[64px]">
        <MountReveal className="flex flex-col items-center gap-[20px] text-center text-brand-white">
          {/* Uppercase in CSS, so screen readers read a word rather than letters. */}
          <p className="font-trimMono text-hsa-hero-eyebrow font-medium uppercase">
            {HSA_FSA_HERO.eyebrow}
          </p>
          <h1
            id="hsa-fsa-hero-heading"
            className="font-ppMori text-hsa-hero-headline font-semibold"
          >
            {HSA_FSA_HERO.headline[0]}
            <br />
            {HSA_FSA_HERO.headline[1]}
          </h1>
          <p className="text-balance font-ppMori text-hsa-hero-subhead font-normal">
            {HSA_FSA_HERO.subhead}
          </p>
        </MountReveal>
        <MountReveal delayMs={80}>
          <Button variant="solid-inverse" href={SITE_LINKS.matic.href}>
            {HSA_FSA_HERO.ctaLabel}
          </Button>
        </MountReveal>
      </div>
    </div>
  </Section>
);

export default HsaFsaHero;
